





import { Component, Vue, Prop } from 'vue-property-decorator'

@Component<MediasLayoutView>({})
export default class MediasLayoutView extends Vue {}
